import { jsx } from "react/jsx-runtime";
import { c as clsx } from "../../../../../../chunks/clsx-DgYk2OaC.js";
const description = "_description_1hx23_1";
const styles = {
  description,
  "description-error": "_description-error_1hx23_9",
  "description-default": "_description-default_1hx23_13"
};
const Description = ({ children, variant, ...props }) => {
  return /* @__PURE__ */ jsx("span", { className: clsx(styles.description, styles[`description-${variant}`]), ...props, children });
};
export {
  Description
};
